import {Component, OnInit} from '@angular/core';
import {
  UserBrandingRepository
} from '../../../infrastructure/repositories/user-branding/user-branding-repository';
import {
  UserBrandingDashboardViewModel
} from './user-branding-dashboard-view.model';
import {CommonModule, NgForOf} from '@angular/common';
import {
  IUserBrandingRepository
} from '../../../domain/user-branding-repository';
import {EvrideoCommonModule} from '../../common/evrideo-common.module';
import {Router, RouterLink} from '@angular/router';
import {UserBrandingSetting} from '../../../domain/user-branding-setting';
import {UI} from '../../../services/ui.service';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'evrideo-user-branding-dashboard',
  templateUrl: './user-branding-dashboard.component.html',
  styleUrl: './user-branding-dashboard.component.scss'
})
export class UserBrandingDashboardComponent implements OnInit {
  public vm: UserBrandingDashboardViewModel
  constructor(
    private _userBrandingRepository: IUserBrandingRepository,
    private _router: Router,
    private _ui: UI,
    private _toastr: ToastrService,
  ) {
    this.vm = new UserBrandingDashboardViewModel(_userBrandingRepository,
      _router,
      _ui,
      _toastr);
  }

  async ngOnInit() {
        await this.vm.onInit();
    }
}
